<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-8 lg:w-6"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Pendência</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">

            <div class="w-full">

                <div class="w-12">

                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText id="descricao" v-model="form.descricao" class="w-full" />
                            <label for="descricao">Descrição<span class="text-red-500">*</span></label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['descricao'] }}</div>
                    </div>

                </div>

                <div class="w-12">
                    <div class="field mt-4">
                        <FloatLabel>
                            <Select
                                id="categoria_id"
                                v-model="form.categoria_id"
                                :options="categoriaOpt"
                                optionLabel="descricao"
                                optionValue="id"
                                class="w-full"
                                filter
                                showClear
                                :loading="isLoadingCategoriaOpt" />
                            <label for="categoria_id">Categoria<span class="text-red-500">*</span></label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['categoria_id'] }}</div>
                    </div>
                </div>


                <div class="field mt-4">
                    <FloatLabel>
                        <Textarea id="observacao" v-model="form.observacao" class="w-full" rows="5" />
                        <label for="observacao">Observação</label>
                    </FloatLabel>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

        <LogForm :visible="visibleLogForm" table="pendencias" :tableId="form.id" @close="this.visibleLogForm=false" />

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';


import Pendencia from '@/service/pendencia.js';
import PendenciaCategoria from '@/service/pendenciaCategoria.js';

import LogForm from '@/components/LogForm.vue';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        Password,
        Button,
        Select,
        Checkbox,
        Textarea,

        LogForm,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,

            categoriaOpt: [],
            isLoadingCategoriaOpt: false,

            visibleLogForm: false,
        }
    },
    methods: {
        onShow() {
            this.errors = {};
            this.form = { ...this.data };
        },
        onHide() {
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Pendencia.update(form.id, form);
            }
            return Pendencia.create(form);
        },
        loadCategoriaOpt() {
            this.isLoadingCategoriaOpt = true;
            PendenciaCategoria.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.categoriaOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingCategoriaOpt = false;
                });
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    mounted() {
        this.loadCategoriaOpt();
    }
}
</script>
